<div class="page">
  <app-page-header page-title="interventions.list.pageTitle"></app-page-header>
  <div class="page-content">

    <mat-card class="custom-card">
      <mat-card-title>{{ 'interventions.list.listTab.title' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'common.words.listTabSubtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <mat-expansion-panel expanded="true" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}"></mat-expansion-panel-header>
          <div class="table-wrapper">
            <div class="table-toolbar">
              <div class="row align-items-center">
                <div class="col-12 col-sm-6 col-md-6">
                  <!-- <mat-form-field>
                    <input matInput placeholder="{{ 'common.words.search' | translate }}" #input>
                    <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="resetInput()"
                      class="reset-input-icon" *ngIf="input.value"></mat-icon>
                  </mat-form-field> -->
                </div> <!-- /.col-12.col-md-4 -->
                <div class="col-12 col-sm-6 col-md-6 text-right">
                  <button mat-button (click)="onExport()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                    {{ 'common.words.export' | translate }}
                  </button>
                  <button mat-button (click)="onResetFilters()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-broom"></mat-icon>
                    {{ 'common.cta.resetFilters' | translate }}
                  </button>
                </div> <!-- /.col-12.col-md-8 -->
              </div> <!-- /.row -->
            </div> <!-- /.table-toolbar -->
            <div class="spinner-container" *ngIf="dataSource.loading$ | async">
              <mat-spinner strokeWidth="3" [diameter]="50" mode="indeterminate"></mat-spinner>
            </div> <!-- /.spinner-container -->
            <div class="table-responsive">
              <table mat-table [dataSource]="dataSource" matSort #sort1="matSort" matSortActive="name"
                matSortDirection="desc" matSortDisableClear class="mat-elevation-z0">
                <ng-container matColumnDef="index">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    {{ i + 1 }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-10">
                    {{ 'interventions.fields.name' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">{{ element.name }}</td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="nameFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(nameFilter)"
                        class="reset-input-icon" *ngIf="nameFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="propertyName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'interventions.fields.propertyName' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.propertyName }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="propertyNameFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(propertyNameFilter)"
                        class="reset-input-icon" *ngIf="propertyNameFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="type">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'interventions.fields.type' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.type }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="typeFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(typeFilter)"
                        class="reset-input-icon" *ngIf="typeFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="meetingResolutionDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'interventions.fields.meetingResolutionDate' | translate }}</th>
                  <td mat-cell *matCellDef="let element">{{ element.meetingResolutionDate | dateFormat }}</td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <input matInput [matDatepicker]="dp" (focus)="dp.open()" (click)="dp.open()" readonly
                        placeholder="{{ 'common.cta.select' | translate }}" [formControl]="meetingResolutionDateFilter"
                        style="cursor: pointer" />
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(meetingResolutionDateFilter)"
                        class="reset-input-icon" *ngIf="meetingResolutionDateFilter.value"></mat-icon>
                      <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                      <mat-datepicker #dp></mat-datepicker>
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-10">
                    {{ 'interventions.fields.status' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-chip-list class="d-block py-2 px-1">
                      <mat-chip *ngIf="element.status === 'open'" selected class="mat-chip-sm chip-green">
                        {{ 'interventions.status.open' | translate }}
                      </mat-chip>
                      <mat-chip *ngIf="element.status === 'closed'" selected class="mat-chip-sm chip-red">
                        {{ 'interventions.status.closed' | translate }}
                      </mat-chip>
                    </mat-chip-list>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <mat-select [formControl]="statusFilter">
                        <mat-option *ngFor="let status of availableStatus" [value]="status">
                          <small>{{ 'interventions.status.' + status | translate }}</small>
                        </mat-option>
                      </mat-select>
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(statusFilter)"
                        class="reset-input-icon" *ngIf="statusFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="constructionStart">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'interventions.fields.constructionStart' | translate }}</th>
                  <td mat-cell *matCellDef="let element">{{ element.constructionStart | dateFormat }}</td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <input matInput [matDatepicker]="dp" (focus)="dp.open()" (click)="dp.open()" readonly
                        placeholder="{{ 'common.cta.select' | translate }}" [formControl]="constructionStartFilter"
                        style="cursor: pointer" />
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(constructionStartFilter)"
                        class="reset-input-icon" *ngIf="constructionStartFilter.value"></mat-icon>
                      <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                      <mat-datepicker #dp></mat-datepicker>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef class="text-right pr-5">{{ 'common.cta.actions' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-right">
                    <a [routerLink]="'../detail/' + element._id" mat-raised-button color="primary"
                      matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                      {{ 'common.cta.open' | translate }}
                      <mat-icon fontSet="fal" fontIcon="fa-long-arrow-right"></mat-icon>
                    </a>
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index;"
                  [class.even-row]="(i % 2) == 0"></tr>
                <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
              </table>
              <mat-paginator [length]="dataSource.totalCount$ | async" [pageSizeOptions]="[10, 15, 20, 50, 75, 100]"
                showFirstLastButtons></mat-paginator>
            </div> <!-- /.table-responsive -->
          </div> <!-- /.table-wrapper -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>
  </div> <!-- /.page-content -->
</div> <!-- /.page -->